<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>商品模型</span>
				<el-button class="button" @click='edit_type("")' type="success">新增模型</el-button>
			</div>
		</template>
		<div class="col">
			<!-- <search></search> -->
			<el-table v-loading="loading" :data="typeData.filter(data => !search || data.product_type_name.toLowerCase().includes(search.toLowerCase()))"
			 style="width: 100%;" :default-sort="sort" border highlight-current-row>
				<el-table-column prop="id" label="编号" sortable width="180">
				</el-table-column>
				<el-table-column prop="product_type_name" label="商品模型名" sortable>
					<template #default="scope">
						<el-popover effect="plain" trigger="hover" placement="top-start">
							<template #default>
								<p>商品模型名: {{ scope.row.product_type_name }}</p>
								<p>商品规格:
									<span v-for="item in scope.row.type_to_spec" :key='item.id'>{{ item.product_spec_name}},</span>
								</p>
							</template>
							<template #reference>
								<div class="name-wrapper">
									<el-tag effect="dark" type="success" size="medium">{{ scope.row.product_type_name }}</el-tag>
								</div>
							</template>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column align="right">
					<template #header>
						<el-input v-model="search" size="medium" placeholder="输入关键字搜索" />
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="edit_type(scope.row)">编辑</el-button>
						<el-button v-if="this.localGet('userId')==1" type="danger" size="medium" @click="destroy(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form :model="item" ref="form" :rules="rules">
			<el-form-item label="模型名称" prop="product_type_name">
				<el-input v-model="item.product_type_name" size="small" placeholder="模型名称"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import Search from '../common/Search.vue'
	export default {
		name: 'ProductType',
		data() {
			return {
				title: '新增模型',
				dialogFormVisible: false,
				typeData: [],
				loading: true,
				sort: {
					prop: 'id',
					order: 'descending'
				},
				item: {
					product_type_name: '',

				},
				search: '',
				rules: {
					product_type_name: [{
						required: true,
						message: '请填写模型名称',
						trigger: 'blur'
					}],
				},
			}
		},
		components: {
			Search
		},
		methods: {
			edit_type(row) {
				console.log(row)
				let temp = this.cloneObj(row);
				if (row) {
					this.title = '编辑模型';
					this.item = temp;
				} else {
					this.resetObj(this.item)
				}
				this.dialogFormVisible = true;

				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			destroy(index, row) {
				console.log(index, row)
				let id = row.id
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/product/productTypeDelete', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getProductType()
				})
			},
			submit() {
				console.log(this.item);
				// return false;

				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.httpPost({
							url: '/admin/product/productTypeUpdate',
							data: this.item
						}).then((re) => {

							console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getProductType();
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})

			},
			getProductType() {
				// typeData
				this.httpPost({
					url: '/admin/product/productTypeList',
					data:{
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.typeData = temp;
					this.loading = false;
					// console.log(this.localGet('userId'))
				}).catch((err) => {
					this.loading = false;
				})
			}
		},
		created() {
			this.getProductType()
		}

	}
</script>

<style>
	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.box-card {
		/* width: 480px; */
	}

	.el-tag--medium {
		height: 40px;
		line-height: 40px;
	}
</style>
